const localPreset = localStorage.getItem('presets')
const allLocalPresets = {}

const parsed = JSON.parse(localPreset)

for (let preset in parsed) {
  allLocalPresets[preset] = parsed[preset]
}

export default allLocalPresets
